export const PHOTO_TYPES = {
  ORIGINAL: 'Original',
  PROFILE: 'Profile',
  FEATURED_PROFILE: 'FeaturedProfile',
  GALLERY: 'Gallery',
  SEARCH_THUMBNAIL: 'SearchThumbnail',
  TEMP_PROFILE: 'TemporaryProfile',
  TEMP_THUMBNAIL: 'TemporaryThumb',
};
